// import React from "react";
// import logo from "../assets/Footer/Logo.svg";
// import { LuDot } from "react-icons/lu";
// import {
//   FaApple,
//   FaGooglePlay,
//   FaInstagram,
//   FaLinkedinIn,
//   FaTwitter,
//   FaYoutube,
// } from "react-icons/fa";
// import { FaFacebookF } from "react-icons/fa";
// import { useAgencyInfo } from "../context/agency";
// import { useUserInfo } from "../context/user";
// import { useNavigate, useParams } from "react-router";

// const Footer = () => {
//   const [agency] = useAgencyInfo();
//   const [user] = useUserInfo();
//   const theme_content = agency?.theme_id?.theme_data;

//   const themeContentObject = theme_content?.content;
//   const navigate = useNavigate();

//   const socialLinks = theme_content?.general;
//   let middleware = `/`;

//   const { agency_id } = useParams();

//   if (agency_id) {
//     middleware = `/app/${agency_id}/`;
//   }

//   return (
//     <footer
//       style={{
//         backgroundColor: socialLinks?.footer_background || "#232020",
//         color: socialLinks?.footer_text || "white",
//       }}
//       className="pt-[60px]"
//     >
//       <div className="max-w-[1170px] w-full px-4 mx-auto flex flex-col md:flex-row">
//         <div className="w-full flex flex-col items-center justify-between lg:flex-row lg:items-start">
//           <img
//             src={
//               theme_content?.general?.footer_logo ||
//               "https://snapshotstore.fra1.digitaloceanspaces.com/Untitled%20design%20%287%29-83731"
//             }
//             alt="Directory"
//             className="mb-[30px] h-11 float-start block w-[150px] object-cover"
//           />

//           <div className="flex flex-col gap-3 items-center lg:items-start lg:flex-row lg:justify-between w-full md:w-[360px]">
//             <div>
//               <p className="text-lg font-bold text-center lg:text-start">
//                 Phone
//               </p>
//               <p className="text-[15px] font-semibold">
//                 {themeContentObject?.phone || "(555) 123-4567"}
//               </p>
//               {themeContentObject?.address.length > 0 ? (
//                 <p className="text-lg font-bold text-center lg:text-start">
//                   Address
//                 </p>
//               ) : (
//                 ""
//               )}
//               <p className="text-[15px] font-semibold">
//                 {themeContentObject?.address}
//               </p>
//             </div>

//             <div>
//               <p className="text-lg font-bold text-center lg:text-start">
//                 Email
//               </p>
//               <p className="text-[15px] font-semibold">
//                 {themeContentObject?.email || "email@smartdirectory.ai"}
//               </p>
//             </div>
//           </div>

//           {/* <div className="my-[60px]">
//             <p className="text-[15px] font-semibold text-white pb-3">Apps</p>

//             <div className="flex">
//               <div className="flex px-[23px] py-[12px] bg-[#212329] rounded-xl mr-[10px] w-[210px]">
//                 <div className="flex justify-center items-center">
//                   <FaApple className="inline mr-2" fontSize={30} />
//                 </div>
//                 <div>
//                   <span
//                     className="text-[13px]  block"
//                     style={{ lineHeight: "19px" }}
//                   >
//                     Download on the
//                   </span>
//                   <span className="text-sm" style={{ lineHeight: "21px" }}>
//                     Apple Store
//                   </span>
//                 </div>
//               </div>

//               <div className="flex px-[23px] py-[12px] bg-[#212329] rounded-xl w-[210px]">
//                 <div className="flex justify-center items-center">
//                   <FaGooglePlay className="inline mr-2" fontSize={25} />
//                 </div>
//                 <div>
//                   <span
//                     className="text-[13px] text-[#BEBDBD] block"
//                     style={{ lineHeight: "19px" }}
//                   >
//                     Get in on
//                   </span>
//                   <span className="text-sm" style={{ lineHeight: "21px" }}>
//                     Google Play
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div> */}

//           {socialLinks && (
//             <div className="">
//               <p
//                 className={`text-[15px] font-semibold pb-3 text-${socialLinks?.Sub_text}`}
//               >
//                 Follow Us on Social Media
//               </p>
//               <div className="flex space-x-2 mt-1">
//                 {socialLinks?.facebook && (
//                   <a
//                     href={socialLinks?.facebook}
//                     target="_blank"
//                     className="w-[40px] h-[40px] cursor-pointer rounded-full hover:bg-[#24252B] flex justify-center items-center"
//                   >
//                     <FaFacebookF fontSize={14} />
//                   </a>
//                 )}

//                 {socialLinks?.twitter && (
//                   <a
//                     href={socialLinks?.twitter}
//                     target="_blank"
//                     className="w-[40px] h-[40px] rounded-full cursor-pointer  hover:bg-[#24252B] flex justify-center items-center"
//                   >
//                     <FaTwitter fontSize={14} />
//                   </a>
//                 )}

//                  {socialLinks?.youtube && (
//                    <a
//                     href={socialLinks?.youtube}
//                     target="_blank"
//                     className="w-[40px] h-[40px] rounded-full cursor-pointer  hover:bg-[#24252B] flex justify-center items-center"
//                   >
//                     <FaYoutube fontSize={14} />
//                   </a>
//                  )}

//                 {socialLinks?.instagram && (
//                   <a
//                     href={socialLinks?.instagram}
//                     target="_blank"
//                     className="w-[40px] h-[40px] rounded-full cursor-pointer  hover:bg-[#24252B] flex justify-center items-center"
//                   >
//                     <FaInstagram fontSize={14} />
//                   </a>
//                 )}

//                 {socialLinks?.linkedin && (
//                   <a
//                     href={socialLinks?.linkedin}
//                     target="_blank"
//                     className="w-[40px] h-[40px] rounded-full cursor-pointer  hover:bg-[#24252B] flex justify-center items-center"
//                   >
//                     <FaLinkedinIn fontSize={14} />
//                   </a>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* <div className="w-full md:w-[60%] mt-10 md:mt-0">
//           <div className="pb-[60px]">
//             <p className="text-[15px] font-semibold text-white pb-5">Apps</p>

//             <div className="h-[70px] w-full px-[30px] rounded-xl bg-[#212329] flex justify-between items-center">
//               <input
//                 type="email"
//                 className="bg-transparent outline-none border-none"
//               />
//               <span className="font-semibold">Subscribe</span>
//             </div>
//           </div>

//           <div className="flex flex-col md:flex-row justify-between">
//             <div className="mb-6 md:mb-0">
//               <h3 className="font-semibold text-[15px] mb-2">
//                 Listings Categories
//               </h3>
//               <p className="text-sm text-[#BEBDBD] pb-2">Restaurants</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Hvac</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Lawyers</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Dental Offices</p>
//             </div>

//             <div className="mb-6 md:mb-0">
//               <h3 className="font-semibold text-[15px] mb-2">Quick Links</h3>
//               <p className="text-sm text-[#BEBDBD] pb-2">Terms of Use</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Privacy Policy</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Pricing Plans</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Our Services</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Contact Support</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Careers</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">FAQs</p>
//             </div>

//             <div>
//               <h3 className="font-semibold text-[15px] mb-2">Discover</h3>
//               <p className="text-sm text-[#BEBDBD] pb-2">Miami</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Los Angeles</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">Chicago</p>
//               <p className="text-sm text-[#BEBDBD] pb-2">New York</p>
//             </div>
//           </div>
//         </div> */}
//       </div>

//       <div className="border-t border-gray-700 py-5 mt-[60px] flex flex-col md:flex-row justify-between text-xs max-w-[1170px] w-full px-4 mx-auto">
//         <div>
//           {themeContentObject?.copyright || "© directory - All rights reserved"}
//         </div>

//         <div
//           className={`flex items-center mt-3 md:mt-0
//               ${
//                 theme_content?.footerPages?.length > 1
//                   ? "divide-x divide-gray-500"
//                   : ""
//               }`}
//         >
//           {theme_content?.footerPages?.map((page, index) => (
//             <p
//               key={index}
//               className="px-2 cursor-pointer"
//               onClick={() =>
//                 navigate(
//                   `${middleware}page-iframe/${encodeURIComponent(page.url)}`
//                 )
//               }
//             >
//               {page.name}
//             </p>
//           ))}
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import { FaInstagram, FaLinkedinIn, FaTwitter, FaYoutube } from "react-icons/fa"
import { FaFacebookF } from "react-icons/fa"
import { useAgencyInfo } from "../context/agency"
import { useUserInfo } from "../context/user"
import { useNavigate, useParams } from "react-router"

const Footer = () => {
  const [agency] = useAgencyInfo()
  const [user] = useUserInfo()
  const theme_content = agency?.theme_id?.theme_data

  const themeContentObject = theme_content?.content
  const navigate = useNavigate()

  const socialLinks = theme_content?.general
  let middleware = `/`

  const { agency_id } = useParams()

  if (agency_id) {
    middleware = `/app/${agency_id}/`
  }

  return (
    <footer
      style={{
        backgroundColor: socialLinks?.footer_background || "#232020",
        color: socialLinks?.footer_text || "white",
      }}
      className="pt-8 sm:pt-12 md:pt-16 lg:pt-[60px]"
    >
      <div className="max-w-[1170px] w-full px-4 sm:px-6 lg:px-8 mx-auto">
        {/* Main footer content */}
        <div className="flex flex-col space-y-8 lg:space-y-0 lg:flex-row lg:justify-between lg:items-start">
          {/* Logo section */}
          <div className="flex justify-center lg:justify-start">
            <img
              src={
                theme_content?.general?.footer_logo ||
                "https://snapshotstore.fra1.digitaloceanspaces.com/Untitled%20design%20%287%29-83731" ||
                "/placeholder.svg"
              }
              alt="Directory"
              className="h-8 sm:h-10 lg:h-11 w-auto max-w-[120px] sm:max-w-[150px] object-cover"
            />
          </div>

          {/* Contact information */}
          <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 lg:gap-12 items-center sm:items-start lg:w-auto">
            <div className="text-center sm:text-left">
              <p className="text-base sm:text-lg font-bold mb-1 sm:mb-2">Phone</p>
              <a href={`tel:${themeContentObject?.phone}`} className="text-sm sm:text-[15px] font-semibold mb-3 sm:mb-4">
                {themeContentObject?.phone || "(555) 123-4567"}
              </a>
              {themeContentObject?.address && themeContentObject.address.length > 0 && (
                <>
                  <p className="text-base sm:text-lg font-bold mb-1 sm:mb-2">Address</p>
                  <p className="text-sm sm:text-[15px] font-semibold">{themeContentObject.address}</p>
                </>
              )}
            </div>

            <div className="text-center sm:text-left">
              <p className="text-base sm:text-lg font-bold mb-1 sm:mb-2">Email</p>
              <p className="text-sm sm:text-[15px] font-semibold break-all sm:break-normal">
                {themeContentObject?.email || "email@smartdirectory.ai"}
              </p>
            </div>
          </div>

          {/* Social media section */}
          {socialLinks && (
            <div className="text-center lg:text-left">
              <p className={`text-sm sm:text-[15px] font-semibold pb-3 text-${socialLinks?.Sub_text}`}>
                Follow Us on Social Media
              </p>
              <div className="flex justify-center lg:justify-start space-x-2 mt-1">
                {socialLinks?.facebook && (
                  <a
                    href={socialLinks?.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[36px] h-[36px] sm:w-[40px] sm:h-[40px] cursor-pointer rounded-full hover:bg-[#24252B] flex justify-center items-center transition-colors duration-200"
                  >
                    <FaFacebookF fontSize={12} className="sm:text-[14px]" />
                  </a>
                )}

                {socialLinks?.twitter && (
                  <a
                    href={socialLinks?.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[36px] h-[36px] sm:w-[40px] sm:h-[40px] rounded-full cursor-pointer hover:bg-[#24252B] flex justify-center items-center transition-colors duration-200"
                  >
                    <FaTwitter fontSize={12} className="sm:text-[14px]" />
                  </a>
                )}

                {socialLinks?.youtube && (
                  <a
                    href={socialLinks?.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[36px] h-[36px] sm:w-[40px] sm:h-[40px] rounded-full cursor-pointer hover:bg-[#24252B] flex justify-center items-center transition-colors duration-200"
                  >
                    <FaYoutube fontSize={12} className="sm:text-[14px]" />
                  </a>
                )}

                {socialLinks?.instagram && (
                  <a
                    href={socialLinks?.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[36px] h-[36px] sm:w-[40px] sm:h-[40px] rounded-full cursor-pointer hover:bg-[#24252B] flex justify-center items-center transition-colors duration-200"
                  >
                    <FaInstagram fontSize={12} className="sm:text-[14px]" />
                  </a>
                )}

                {socialLinks?.linkedin && (
                  <a
                    href={socialLinks?.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[36px] h-[36px] sm:w-[40px] sm:h-[40px] rounded-full cursor-pointer hover:bg-[#24252B] flex justify-center items-center transition-colors duration-200"
                  >
                    <FaLinkedinIn fontSize={12} className="sm:text-[14px]" />
                  </a>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Footer bottom section */}
        <div className="border-t border-gray-700 py-4 sm:py-5 mt-8 sm:mt-12 lg:mt-[60px] flex flex-col sm:flex-row justify-between items-center sm:items-start text-xs sm:text-sm">
          <div className="mb-3 sm:mb-0 text-center sm:text-left">
            {themeContentObject?.copyright || "© directory - All rights reserved"}
          </div>

          <div
            className={`flex flex-wrap justify-center sm:justify-end items-center gap-x-1 sm:gap-x-0
                ${theme_content?.footerPages?.length > 1 ? "sm:divide-x sm:divide-gray-500" : ""}`}
          >
            {theme_content?.footerPages?.map((page, index) => (
              <p
                key={index}
                className="px-2 py-1 sm:py-0 cursor-pointer hover:text-gray-300 transition-colors duration-200 text-center"
                onClick={() => navigate(`${middleware}page-iframe/${encodeURIComponent(page.url)}`)}
              >
                {page.name}
              </p>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
